import React, { Component } from 'react';
import fp from 'lodash/fp';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Link, withRouter } from 'react-router-dom';

import * as ROUTES from 'config/routes';
import FilterBar from './components/filter-bar';
import ListView from './components/list-view';
import TileView from './components/tile-view';
import ViewModeHeader from './components/view-mode-header';
import { Col, Row, TextInput } from 'elements';
import { holdersSelector, holderListIsLoadingSelector } from 'redux/selectors';
import { jsonToQueryString, parseQueryString } from 'utils/helpers';
import { listHolders } from 'redux/modules/model/holder';
import { logUserTab } from 'redux/modules/user/index'
import { withClientId } from 'hocs';
import * as actions from '@/redux/new_store_structure/actions';

const predicate = criteria => item => {
	if (criteria.search) {
    return item.name.toUpperCase()
      .concat(item.clientReference.toUpperCase())
      .includes(criteria.search.toUpperCase());
	}
	if (!criteria.showAll) {
		return item.active;
	}
	return true;
};

class ContactList extends Component {
	static propTypes = {
		history: PropTypes.object.isRequired,
		holders: PropTypes.array.isRequired,
		location: PropTypes.object.isRequired,
		logUserTab: PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);
		this.state = {
			search: null,
		};
	}

	componentDidMount() {
		const { clientId, getHoldersList,logUserTab } = this.props;
		getHoldersList({
			clientId,
			with: ['metadata', 'detectable-type'],
		});
		const tab = "Directory"
    	logUserTab({ clientId, tab})
	}

	setURLHref = params => {
		const { history } = this.props;
		history.push({
			location: ROUTES.DIRECTORY,
			search: jsonToQueryString(params),
		});
	};

	handleViewModeChange = (view, page, perPage) => {
		const { location } = this.props;
		const params = {
			...parseQueryString(location.search),
			view,
			page,
			perPage,
		};
		this.setURLHref(params);
	};

	handleSearchChange = e => {
		this.setState({
			search: e.target.value,
		});
		const params = {
			...parseQueryString(location.search),
			search: e.target.value,
			page: '1',
		};
		this.setURLHref(params);
	};
	handleTableChanges = (pagination, filters, sorter) => {
		const params = {
			...parseQueryString(location.search),
			sort: sorter.field,
			order: sorter.order,
		};
		this.setURLHref(params);
	};

	render() {
		const { holders, location, loading } = this.props;
		const params = parseQueryString(location.search);
		const {
			view = 'list',
			page = '1',
			perPage = '25',
			sorter = 'name',
			order = 'ascend',
		} = params;
		const criteria = {
			...params,
			search: this.state.search || params.search,
		};
		const filteredHolders = fp.filter(predicate(criteria))(holders);
		return (
			<div>
				<FilterBar
					setURLHref={this.setURLHref}
					onSearchChange={this.handleSearchChange}
				/>
				<ViewModeHeader
					onViewModeChange={this.handleViewModeChange}
					viewMode={view}
					page={page}
					perPage={perPage}
					resultCount={filteredHolders.length}
				/>
				{view === 'list' && (
					<ListView
						loading={loading}
						holders={filteredHolders}
						onTableChange={this.handleTableChanges}
						onPageChange={this.handleViewModeChange}
						page={page}
						perPage={perPage}
						sorter={sorter}
						order={order}
					/>
				)}
				{view === 'large-tile' && (
					<TileView
						holders={filteredHolders}
						loading={loading}
						key="tile-view"
						viewMode="large"
						onPageChange={this.handleViewModeChange}
						page={parseInt(page, 10)}
						perPage={parseInt(perPage, 10)}
						sorter={sorter}
						order={order}
					/>
				)}
				{view === 'small-tile' && (
					<TileView
						holders={filteredHolders}
						loading={loading}
						key="tile-view"
						viewMode="small"
						onPageChange={this.handleViewModeChange}
						page={parseInt(page, 10)}
						perPage={parseInt(perPage, 10)}
						sorter={sorter}
						order={order}
					/>
				)}
			</div>
		);
	}
}

const mapStateToProps = ({ holders }) => {
	return {
		loading: holders.loading,
		holders: holders.list,
	};
};

const mapDispatchToProps = dispatch => ({
	getHoldersList: params => dispatch(actions.getHoldersList(params)),
	logUserTab: params => dispatch(logUserTab(params))
});

export default compose(
	withRouter,
	withClientId,
	connect(
		mapStateToProps,
		mapDispatchToProps,
	),
)(ContactList);



// WEBPACK FOOTER //
// ./src/pages/directory/contact-list/index.js